<script setup lang="ts">
import { scrollToTop } from '@/utils/util'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { auditModeShow } from '@/utils/util'

const route = useRoute()
const props = defineProps<{
  activeClass: string
}>()

const isActive = computed(() => {
  return route.path.startsWith('/life/')
})
</script>

<template>
  <RouterLink to="/life/list" replace :aria-label="$t('life_page.title')" custom v-slot="{ navigate }">
    <div
      @click="
        () => {
          navigate()
          scrollToTop()
        }
      "
      :class="[
        isActive ? activeClass : 'text-second',
        'flex flex-col items-center place-content-center h-full flex-1 coarse-pointer:select-none'
      ]">
      <div i-solar:book-linear text-6.5 />
      <div text-xs mt-0.5>
        {{ auditModeShow || inMiniprograme ? $t('life_page.title_audit') : $t('life_page.title') }}
      </div>
    </div>
  </RouterLink>
</template>
